// Helpers de texto de presentación (formularios web) — [RGM] 2026-10-02.

/**
 * Capitaliza la primera letra de CADA palabra sin romper números ni símbolos
 * ("calle 5 # 3-40" → "Calle 5 # 3-40"). Regla de Rafael (2026-10-02): todos
 * los campos de texto LIBRE de los formularios capitalizan la primera letra,
 * consistente con el móvil (TextCapitalization.words) — EXCEPTO los campos de
 * NOMBRES que ya fuerzan mayúscula completa (.toUpperCase()) y los campos
 * técnicos (email, contraseña, cédulas/códigos, filtros/buscadores).
 *
 * `\p{L}+` agrupa solo letras Unicode: los dígitos y separadores quedan
 * intactos. [RGM] 2026-10-02.
 */
export const capitalizarPalabras = (v: string): string =>
  v.replace(/\p{L}+/gu, (p) => p[0].toUpperCase() + p.slice(1))
